/* eslint-disable @next/next/no-img-element */
"use client";

import Image from "next/image";
import Link from "next/link";
import { Box, Button, Grid, Stack, Typography } from "@mui/material";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import CtaButton from "../../buttonWithArrow";

export default function BlogListItem({
    href,
    imageSrc,
    imageAlt = "Blog cover",
    category,
    title,
    excerpt,
}) {

    // console.log("excerpt",excerpt);

    return (
        <Box component="article" sx={{ width: "100%" }}>
            <Grid container spacing={3} alignItems="center">
                {/* Image */}
                <Grid item xs={12} md={5}>
                    <Box sx={{ position: "relative", width: "100%", aspectRatio: "16 / 9", borderRadius: 3, overflow: "hidden" }}>
                        <Image src={imageSrc}
                            alt={imageAlt} fill sizes="(max-width: 900px) 100vw, 40vw" style={{ objectFit: "cover" }} />
                    </Box>
                </Grid>

                {/* Content */}
                <Grid item xs={12} md={7}>
                    <Stack spacing={1.5}>
                        <Typography sx={{ fontSize: 16, letterSpacing: 4, fontWeight: 600, color: "#59AEB6" }}>
                            {category.toUpperCase()}
                        </Typography>

                        <Link href={href} style={{ textDecoration: "none", marginTop: "6px" }}>
                            <Typography
                                component="h3"
                                sx={{ fontWeight: 700, color: "#0F172A", fontSize: { xs: 22, md: 36 }, lineHeight: 1.25 }}
                            >
                                {title}
                            </Typography>
                        </Link>

                        {/* <Typography sx={{ color: "rgba(15,23,42,0.6)", fontSize: 15, lineHeight: 1.75 }}>
                            {excerpt}
                        </Typography> */}

                        <Typography
                            sx={{
                                color: "rgba(15,23,42,0.6)",
                                fontSize: 15,
                                lineHeight: 1.75,
                            }}
                            title={excerpt}
                        >
                            {excerpt
                                ? excerpt.length > 60
                                    ? excerpt.substring(0, 50) + "..."
                                    : excerpt
                                : ""}
                        </Typography>


                        <Stack alignItems="start" sx={{ mt: { xs: 2, md: 2 }, mb: { xs: 2, md: 6 } }}>
                            <CtaButton label="Read More" href={href} endIconSrc="/img/header/VectorRight.svg" />
                        </Stack>
                    </Stack>
                </Grid>
            </Grid>
        </Box>
    );
}
